import { useTranslation } from 'react-i18next'
import getQueryVariable from 'helpers/getQueryVariable'

import Document from 'js/components/Document'
import Section from 'js/components/Section/Section'
import UserList from 'js/components/UserList/UserList'

const List = () => {
    const { t } = useTranslation()

    const q = getQueryVariable('q') || ''

    return (
        <>
            <Document title={t('user.name', { count: 2 })} />
            <Section backgroundColor="white" grow>
                <UserList defaultQuery={q} />
            </Section>
        </>
    )
}

export default List
